import styled from 'styled-components';

//miranda tokens
import { getToken } from '@loadsmart/miranda-tokens';
import { screen } from '@/helpers/screen';

export const FactsTable = styled.table`
  width: min(832px, 100%);
  max-width: 832px;
  margin: var(--gap-h2, 56px) auto 0;
  border-collapse: separate;
  border-spacing: 0;
  border: 1px solid rgb(${getToken('color-background-tertiary')});
  border-radius: 12px;
  overflow: hidden;
  background: #fff;
  font: 400 16px/1.6 ${getToken('font-family-default')};
  color: rgb(${getToken('color-text-primary')});

  thead {
    display: none;
  }

  tbody tr {
    display: block;
    border-bottom: 1px solid rgb(${getToken('color-background-tertiary')});
  }

  tbody tr:last-child {
    border-bottom: 0;
  }

  tbody th,
  td {
    display: block;
    width: auto;
    border: 0;
    padding: 10px 16px;
    text-align: left;
    vertical-align: top;
  }

  tbody th {
    padding-bottom: 2px;
    background: #fff;
    font-size: 14px;
    font-weight: 700;
    color: rgb(${getToken('color-primary-60')});
  }

  td {
    padding-top: 0;
    padding-bottom: 14px;
  }

  ${screen.md} {
    thead {
      display: table-header-group;
    }

    thead th {
      padding: 14px 20px;
      background: rgb(${getToken('color-background-inverted')});
      color: rgb(${getToken('color-text-inverted')});
      text-align: left;
      font: 700 14px/1 ${getToken('font-family-title')};
      text-transform: uppercase;
    }

    tbody tr {
      display: table-row;
      border-bottom: 0;
    }

    tbody th,
    td {
      display: table-cell;
      padding: 14px 20px;
      border-bottom: 1px solid rgb(${getToken('color-background-tertiary')});
    }

    tbody th {
      width: 24%;
      font-size: 16px;
      background: rgb(${getToken('color-background-secondary')});
    }

    tbody tr:last-child th,
    tbody tr:last-child td {
      border-bottom: 0;
    }
  }
`;
